import { render, h } from "preact";
import { ping } from "../utils";
import { LandingPage } from "./LandingPage";

ping();

window.addEventListener("load", () => {
  render(h(LandingPage, null), document.body);
});
